import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import addLocation from "@/views/coachmanage/teammanage/component/addLocation.vue";
export default {
  mixins: [popUp],
  components: {
    addLocation: addLocation
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: '',
        name: "",
        logo: "",
        introduction: "",
        age_group: '',
        can_register: "",
        registration_fee: "",
        venue_id: '',
        location_name: '',
        team_vibe: []
      },
      imgList: [],
      ageGroupList: [],
      venuesLists: [],
      rules: {
        name: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }],
        logo: [{
          required: true,
          message: "请上传球队logo",
          trigger: "blur"
        }],
        age_group: [{
          required: true,
          message: "请输入年龄组",
          trigger: "blur"
        }],
        can_register: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        location_name: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        registration_fee: [{
          required: true,
          message: "请输入报名费用",
          trigger: "blur"
        }],
        introduction: [{
          required: true,
          message: "请输入简介",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas, teamVibe;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.getAgeGroupListFn();

                _this.getVenuseListFn();

                if (data) {
                  _this.copyPrimitive();

                  datas = JSON.parse(JSON.stringify(data));
                  teamVibe = data.team_vibe ? JSON.parse(data.team_vibe) : [];
                  datas.team_vibe = teamVibe.map(function (item) {
                    return {
                      value: item
                    };
                  });
                  datas.location_name = datas.venue ? datas.venue.location_name : '';
                  _this.formData.id = datas.id, _this.formData.name = datas.name, _this.formData.logo = datas.logo, _this.formData.introduction = datas.introduction, _this.formData.age_group = datas.age_group, _this.formData.can_register = datas.can_register, _this.formData.registration_fee = datas.registration_fee, _this.formData.venue_id = datas.venue_id, _this.formData.location_name = datas.location_name, _this.formData.team_vibe = datas.team_vibe, _this.imgList = [datas.logo];

                  _this.copyData();
                }

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    changeLocation: function changeLocation(data) {
      if (data) {
        var newData = data.split(",");
        this.formData.venue_id = newData[0];
        this.formData.location_name = newData[1];
      }
    },
    getAgeGroupListFn: function getAgeGroupListFn() {
      var _this2 = this;

      this.$api.ageGroupList().then(function (res) {
        if (res.code == 200) {
          _this2.ageGroupList = res.data;
        }
      });
    },
    getVenuseListFn: function getVenuseListFn() {
      var _this3 = this;

      this.$api.venuesList({
        is_team: 2,
        page_size: 1000
      }).then(function (res) {
        if (res.code == 200) {
          _this3.venuesLists = res.data.list;
        }
      });
    },
    imgChange: function imgChange(e) {
      this.imgList = e;
      this.formData.logo = e[0] && e[0].response ? e[0].response.url : '';
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.imgList = isClear ? [] : this.formDataMake.logo ? [this.formDataMake.logo] : [];
      this.clearData(isClear);
      this.formData = {
        id: '',
        name: "",
        logo: "",
        introduction: "",
        age_group: '',
        can_register: "",
        registration_fee: "",
        venue_id: '',
        location_name: '',
        team_vibe: []
      };
      this.ageGroupList = [];
      this.venuesLists = []; // 重置表单验证

      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
    },
    addContent: function addContent() {
      this.formData.team_vibe.push({
        value: ''
      });
    },
    removeContent: function removeContent(item) {
      var index = this.formData.team_vibe.indexOf(item);

      if (index !== -1) {
        this.formData.team_vibe.splice(index, 1);
      }
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var reqFn = _this4.formData.id ? 'updateTeams' : 'addTeams';
                    var data = JSON.parse(JSON.stringify(_this4.formData));
                    data.team_vibe = data.team_vibe.map(function (item) {
                      return item.value;
                    });
                    data.team_vibe = JSON.stringify(data.team_vibe);

                    _this4.$api[reqFn](data).then(function (res) {
                      if (res.code == 200) {
                        _this4.$message.success('操作成功');

                        _this4.$emit('change');

                        _this4.dialogFormVisible = false;
                      } else {
                        _this4.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};